import BaseMap from './base-map'

const TailorMadeMap = (function() {

	const init = function(mapEl) {
		if (typeof moresoda === "undefined") {
			setTimeout(init, 200);
		} else {
			const options = {
				center: new google.maps.LatLng(moresoda.mapMarkers[0].lat, moresoda.mapMarkers[0].lng),
				streetViewControl: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};
			const map = BaseMap.init(mapEl, options);
			loadMap(map);
			registerButtons(map, mapEl);
		}
	}

	const loadMap = function(map) {
		var infoWindow = new google.maps.InfoWindow();

		//Create LatLngBounds object.
		var latlngbounds = new google.maps.LatLngBounds();

		for (var i = 0; i < moresoda.mapMarkers.length; i++) {
			var data = moresoda.mapMarkers[i]
			var myLatlng = new google.maps.LatLng(data.lat, data.lng);
			var marker = new google.maps.Marker({
				position: myLatlng,
				map: map,
				title: data.title,
				icon: '/img/pin-hollow--sm.png'
			});
			(function (marker, data) {
				google.maps.event.addListener(marker, "click", function (e) {
					map.panTo(marker.getPosition());
					infoWindow.setContent(`<div><div class="marker"><div class="marker__row"><div class="marker__col marker__col--image"><img src="${data.image}" alt="${data.title}" class="img marker__img"></div><div class="marker__col marker__col--content"><h4 class="marker__title">${data.title}</h4><p>${data.description}</p></div></div></div></div>`);
					infoWindow.open(map, marker);
				});
			})(marker, data);

			//Extend each marker's position in LatLngBounds object.
			latlngbounds.extend(marker.position);

			moresoda.mapMarkers[i].marker = marker;
		}

		//Get the boundaries of the Map.
		var bounds = new google.maps.LatLngBounds();

		//Center map and adjust Zoom based on the position of all markers.
		map.setCenter(latlngbounds.getCenter());
		map.fitBounds(latlngbounds);
	}

	const registerButtons = function(map, mapEl) {
		document.querySelectorAll('.tailor-made__trigger').forEach(function(item) {
			item.addEventListener('click', function(){
				var itemMarker = item.getAttribute('href');
				var marker = moresoda.mapMarkers[moresoda.mapMarkers.findIndex(item => item.id === itemMarker)].marker;
				google.maps.event.trigger(marker, 'click');
				doSomeBouncing(marker);
				zoomMap(map);
				smoothScroll(mapEl);
			})
		});
	}

	const doSomeBouncing = function(marker) {
		marker.setAnimation(google.maps.Animation.BOUNCE);
		setTimeout(() => {
			marker.setAnimation(null);
		}, 3000);
	}

	const zoomMap = function(map) {
		map.setZoom(12);
	}

	const smoothScroll = function(el) {
		document.querySelector(el).scrollIntoView({
			behavior: 'smooth',
			block: 'center'
		});
	}

	return {
		init: init
	};

})();

export default TailorMadeMap;